export const SECRET_KEY = 'cJ7vr9rs0tvIM8w6Rl5CMMnAZe4qL6xE';

export const NODE_ENV = {
	DEVELOPMENT: 'development',
	PRODUCTION: 'production'
}


export const ERROR_MESSAGE = {
	NORMAL: 'Có lỗi xảy ra, xin vui lòng thử lại sau!',
}

export const SERVER_RESPONSE_CODE = {
	Success: 0,
};

export const TYPE_OS = {
	IOS: "iOS",
	ANDROID:"Android"
}
